import { Button, Grid, Stack } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DocManagementService from 'src/components/eTMF/documentUpload/service/DocManagementService';
import { useGetStudiesQuery } from 'src/components/Services/Utils';
import { AppState, useAppSelector } from 'src/store';
import { useAppDispatch } from 'src/store/hooks';
import { setSearchDetail } from 'src/store/searchHierarchyDetails';
import { setUserDataAvailable } from 'src/store/User';
import './DashboardNavbar.scss';
import Menu from './Menu';
import { getPoratlHost } from 'src/components/common/hooks/useUtil';

const SearchHierarchy = ({ searchData, tab, row, setSiteDataList, isVersionCheck }: any) => {
  const [studyList, setStudyList] = useState<any>([]);
  const [countrylist, setCountryList] = useState<any>([]);
  const [sitelist, setSiteList] = useState<any>([]);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement[]>([]);
  const docService = new DocManagementService();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const documentKey: any = useAppSelector(state => state.preferences.documentKey);
  const user: any = useAppSelector(state => state.user.user);
  const Sponsor = '';
  const [searchFilter, setSearchFilter] = useState({
    Sponsor: Sponsor,
    Study: SearchHierarchyDetail?.data[0]?.Study ? SearchHierarchyDetail?.data[0]?.Study : '',
    Country: SearchHierarchyDetail?.data[0]?.Country ? SearchHierarchyDetail?.data[0]?.Country : '',
    Site: SearchHierarchyDetail?.data[0]?.Site ? SearchHierarchyDetail?.data[0]?.Site : ''
  });

  const tabs = [
    {
      key: 2,
      label: 'Study',
      value: searchFilter.Study,
      options: studyList
    },
    {
      key: 3,
      label: 'Country',
      value: searchFilter.Country,
      options: countrylist
    },
    {
      key: 4,
      label: 'Site',
      value: searchFilter.Site,
      options: sitelist
    }
  ];

  const handleMenuItemClick = (event: any, index: number) => {
    setSelectedIndex(index);
    setSearchFilter({ ...searchFilter, Study: event.target.value });
    setOpen(false);
  };

  const dispatch = useAppDispatch();
  const { isLoading, data: studyData, isError, isSuccess, refetch: getStudyList } = useGetStudiesQuery();
  useEffect(() => {
    const temp: string[] = [];
    if (studyData && studyData.length != 0) {
      studyData.map((study: any) => {
        temp.push(study.name);
      });
      //setSearchFilter({ ...searchFilter, Study: temp[0] });
      dispatch(setUserDataAvailable(true));
    } else {
      dispatch(setUserDataAvailable(false));
    }
    setStudyList([...new Set(temp)]);
    const studyCheck =
      SearchHierarchyDetail?.data[0]?.Study == undefined || SearchHierarchyDetail?.data[0]?.Study == ''
        ? temp[0]
        : SearchHierarchyDetail?.data[0]?.Study;
    if (documentKey?.study_id && documentKey?.study_id !== null) {
      setSearchDetail(dispatch, [
        { ...searchFilter, Study: documentKey?.study_id, Country: documentKey?.country, Site: documentKey?.site_id }
      ]);
      setSearchFilter({
        ...searchFilter,
        Study: documentKey?.study_id,
        Country: documentKey?.country,
        Site: documentKey?.site_id
      });
      setCurrentStudy(documentKey?.study_id);
    } else {
      setSearchDetail(dispatch, [{ ...searchFilter, Study: studyCheck }]);
      setSearchFilter({ ...searchFilter, Study: studyCheck });
      setCurrentStudy(studyCheck);
    }
  }, [studyData, documentKey?.study_id]);

  const [currentStudy, setCurrentStudy] = useState(
    SearchHierarchyDetail?.data[0]?.Study ? SearchHierarchyDetail?.data[0]?.Study : searchFilter.Study
  );
  const [currentCountry, setCurrentCountry] = useState(
    SearchHierarchyDetail?.data[0]?.Country ? SearchHierarchyDetail?.data[0]?.Country : ''
  );

  useEffect(() => {
    if (currentStudy && studyData) {
      let sponsorVal = '';
      const currentStudyObj: any = studyData?.filter((studyInfo: any) => studyInfo.name === currentStudy);
      if (currentStudyObj) sponsorVal = currentStudyObj[0]?.sponsor_name;

      window.parent.postMessage(
        { action: 'SPONSOR_NAME', slug_id: 'ISF', selected_sponsor: sponsorVal },
        getPoratlHost() as string
      );
      setSearchFilter({ ...searchFilter, Sponsor: sponsorVal });
    }
  }, [currentStudy, studyData]);

  /**
   *  Get studies - bharath
   */

  const searchDetails = (study: string, country: string, site: string) => {
    searchData(study, country, site);
  };

  useEffect(() => {
    getStudyList();
  }, []);

  useEffect(() => {
    if (row) {
      let sponsorVal = '';
      if (studyData) {
        const currentStudyObj: any = studyData?.filter((studyInfo: any) => studyInfo.name === row.isf_doc_study);
        if (currentStudyObj) sponsorVal = currentStudyObj[0]?.sponsor_name;
      }
      setSearchFilter({
        ...searchFilter,
        Sponsor: sponsorVal,
        Study: row.isf_doc_study,
        Country: row.isf_doc_country,
        Site: row.isf_doc_site
      });
    }
  }, [row]);

  return (
    <div>
      <Grid container>
        <Grid md={12}>
          <div className="study-hierarchy-menu">
            <Stack direction="row" spacing={2}>
              {' '}
              <Button variant="contained">
                Sponsor:&nbsp;<span> {' ' + `${searchFilter?.Sponsor ?? ''}`}</span>
              </Button>
              {tabs.map((item, i) => (
                <Menu
                  key={i}
                  item={item}
                  handleMenuItemClick={handleMenuItemClick}
                  searchFilter={searchFilter}
                  studyList={studyList}
                  setCountryList={setCountryList}
                  setSiteList={setSiteList}
                  setSearchFilter={setSearchFilter}
                  countrylist={countrylist}
                  searchDetails={searchDetails}
                  sitelist={sitelist}
                  currentStudy={currentStudy}
                  setCurrentStudy={setCurrentStudy}
                  currentCountry={currentCountry}
                  setCurrentCountry={setCurrentCountry}
                  setSiteDataList={setSiteDataList}
                  isVersionCheck={isVersionCheck}
                  studyData={studyData}
                />
              ))}
            </Stack>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(SearchHierarchy);
